import { useLayoutEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { auth0Client } from '#/utils/auth/auth0Client';

/**
 * Auth0のApplication Login URIのためのエンドポイント
 *
 * Auth0のログイン画面を直接開くための踏み台ページであり、またLPからAuth0サインアップ画面を開くための踏み台ページでもある
 */
export function Login() {
  const [searchParams] = useSearchParams();
  useLayoutEffect(() => {
    const screenHintParam = searchParams.get('screen_hint') ?? undefined;
    auth0Client.loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/home`,
        screen_hint: screenHintParam,
      },
    });
  }, [searchParams]);
  return null;
}
